export default {
  resetPasswordToYourAccount: "Reset your account password",
  password: "Password",
  confirmPassword: "Confirm Password",
  resetPassword: "Reset Password",
  signIn: "Sign In",
};
